(function () {
  if (window.__absShareCopyBound) return;
  window.__absShareCopyBound = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-abs-share-copy]');
    if (!button) return;
    var url = button.getAttribute('data-share-url');
    var label = button.querySelector('[data-share-label]');
    var original = label ? label.textContent : '';

    function confirmCopy() {
      if (label) label.textContent = 'Link copiat';
      window.setTimeout(function () {
        if (label) label.textContent = original;
      }, 1800);
    }

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(confirmCopy);
      return;
    }

    var field = document.createElement('textarea');
    field.value = url;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    document.execCommand('copy');
    field.remove();
    confirmCopy();
  });
})();
